import { Container, Form, Button, Modal } from "react-bootstrap";
import { toast } from "wc-toast";
import { apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
const SetUnmatchLimit = ({ onClose, object, getMatchData }) => {
  const { register, handleSubmit, watch, setValue } = useForm();
  const onSubmit = async (body) => {
    let obj = [
      {
        minOdds: body?.minOdds,
        maxOdds: body?.maxOdds,
        unmatched: body?.unmatched,
      },
    ];
    let objNew = {};
    if (object?.type == "series") {
      objNew = {
        seriesId: object?.data?.seriesId,
        unmatched: obj,
      };
    } else {
      objNew = { eventId: object?.data?.eventId, unmatched: obj };
    }

    try {
      let response = await apiPost(pathObj.updateBlockListinStatus, objNew);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        getMatchData();
        onClose();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    let list = object?.data?.unmatched;
    if (list?.length > 0) {
      setValue("minOdds", list[0]?.minOdds);
      setValue("maxOdds", list[0]?.maxOdds);
      setValue("unmatched", list[0]?.unmatched);
    }
  }, [object]);
  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-status">
          {" "}
          Update UnMatch -{" "}
          {object?.type == "series"
            ? object?.data?.seriesName
            : object?.data?.eventName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="">
          <Container fluid>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Form.Group
                  style={{ marginRight: "15px" }}
                  className="d-flex align-items-start flex-column"
                >
                  <Form.Label
                    style={{ fontSize: "16px" }}
                    className="pe-2 mb-2 w-lg-auto"
                  >
                    Min Odds
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="minAmount"
                    placeholder="Min Odds"
                    {...register(`minOdds`, {
                      required: {
                        values: false,
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group
                  style={{ marginRight: "15px" }}
                  className="d-flex align-items-start flex-column"
                >
                  <Form.Label
                    style={{ fontSize: "16px" }}
                    className="pe-2 mb-2 w-lg-auto"
                  >
                    Max Odds
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="maxAmount"
                    placeholder="Max Odds"
                    {...register(`maxOdds`, {
                      required: {
                        values: false,
                      },
                      validate: (value) => {
                        if (Number(watch(`minOdds`)) > Number(value)) {
                          return "max should be greater than min";
                        }
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group
                  style={{ marginRight: "15px" }}
                  className="d-flex align-items-start flex-column"
                >
                  <Form.Label
                    style={{ fontSize: "16px" }}
                    className="pe-2 mb-2 w-lg-auto"
                  >
                    On / Off
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    className="p-0"
                    {...register(`unmatched`, {
                      required: {
                        values: false,
                      },
                    })}
                  />
                </Form.Group>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="submit"
                  style={{
                    color: "black",
                    padding: "6px",
                    marginRight: "10px",
                  }}
                  className="green-btn"
                >
                  Set Limit
                </Button>{" "}
                <Button
                  type="button"
                  onClick={() => onClose()}
                  className="theme_light_btn btn btn-primary"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Container>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default SetUnmatchLimit;
